import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./index.css";
import mitt from "mitt";

const emitter = mitt();

// listen to an event
emitter.on('foo', e => console.log('foo', e) );

// listen to all events
emitter.on('*', (type, e) => console.log(type, e) );

// fire an event
emitter.emit('foo', { a: 'b' });

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");

